export default ({...props}) => {
  const {space} = props.theme
  return `
    & > [ap_atom_name="stackAtom"] {
      & > *:nth-child(2) {
        flex-grow: 1;
        text-align: center;
        justify-content: center;
      }
    }
    .gap{
      display: inline-block;
      padding: 0px ${space(1)}px;
    }
  `
}
